import axios from "./index";
const URL = "/";
let api = {
  // 首页
  home: {
    homePageCount: params => axios.get(URL + "common/homePageCount", params),//首页统计
    homeWeekRecharge: params => axios.get(URL + "common/homeWeekRecharge", params),//首页周充值
    homeUserMap: params => axios.get(URL + "common/homeUserMap", params),//用户会员比例
    homeUserRegister: params => axios.get(URL + "common/homeUserRegister", params),//首页周注册

  },
  common: {
    upload: params => axios.post(URL + "common/upload", params), // 上传图片
    is_login: params => axios.post(URL + "common/is_login", params), // 是否登录
    login: params => axios.post(URL + "common/login", params), // 登录
    logout: params => axios.get(URL + "common/logout", params), // 退出
  },
  //菜单管理
  menus: {
    index: params => axios.get(URL + "adminMenus/index", params),
    add: params => axios.post(URL + "adminMenus/addMenus", params),
    edit: params => axios.post(URL + "adminMenus/editMenus", params),
    del: params => axios.post(URL + "adminMenus/delMenus", params),
    updata: params => axios.post(URL + "adminMenus/updateMenusStatus", params),

  },
  // 权限管理
  permissions: {
    index: params => axios.get(URL + "adminMenus/permissionIndex", params),
    edit: params => axios.post(URL + "adminMenus/editPermission", params),
    add: params => axios.post(URL + "adminMenus/addPermission", params),
    del: params => axios.post(URL + "adminMenus/delPermission", params),
  },
  // 权限管理
  admin: {
    index: params => axios.get(URL + "admins/index", params),
    add: params => axios.post(URL + "admins/adminAdd", params),
    edit: params => axios.post(URL + "admins/adminEdit", params),
    password: params => axios.post(URL + "admins/adminUpdatePwd", params),
  },
  // 角色管理
  role: {
    index: params => axios.get(URL + "adminMenus/roleIndex", params),
    add: params => axios.post(URL + "adminMenus/addRole", params),
    edit: params => axios.post(URL + "adminMenus/editRole", params),
    del: params => axios.post(URL + "adminMenus/delRole", params),
    editRolePage: params => axios.post(URL + "adminMenus/editRolePage", params),
    editRole: params => axios.post(URL + "adminMenus/editRole", params),
    addRole: params => axios.post(URL + "adminMenus/addRolePage", params),
  },
  // 商品管理
  goods: {
    index: params => axios.get(URL + "goods/index", params),
    add: params => axios.post(URL + "goods/goodsAdd", params),
    edit: params => axios.post(URL + "goods/goodsEdit", params),
    status: params => axios.post(URL + "goods/updateGoodsStatus", params),
    goodsLevel: params => axios.get(URL + "goodsLevel/index", params),
  },
  // 订单列表
  orders: {
    index: params => axios.get(URL + "order/index", params),
    cancel: params => axios.post(URL + "order/orderCancel", params),
    delivery: params => axios.post(URL + "order/orderDelivery", params)
  },

  //图片列表
  images: {
    upload: params => axios.post(URL + "images/upload", params),
    index: params => axios.get(URL + "images/index", params),
  },
  // 盲盒分类
  blindCate: {
    index: params => axios.get(URL + "blindCate/index", params),
    add: params => axios.post(URL + "blindCate/addBlindCate", params),
    edit: params => axios.post(URL + "blindCate/editBlindCate", params),
    status: params => axios.post(URL + "blindCate/updateCateStatus", params),
    boxDrawRecord: params => axios.get(URL + "common/boxDrawRecord", params),
    
  },
  // 宝箱列表
  treasureList: {
    index: params => axios.get(URL + "challengeBox/treasureList", params),
    add: params => axios.post(URL + "challengeBox/addOtherTreasure", params),
    treasurePrizeList: params => axios.get(URL + "challengeBox/treasurePrizeList", params),
    addTreasurePrize: params => axios.post(URL + "challengeBox/addTreasurePrize", params),
    del: params => axios.post(URL + "challengeBox/delTreasurePrize", params),
  },
  // 无限池盲盒列表
  blindBox: {
    index: params => axios.get(URL + "blindBox/index", params),
    add: params => axios.post(URL + "blindBox/addBlindBox", params),
    edit: params => axios.post(URL + "blindBox/editBlindBox", params),
    detail: params => axios.get(URL + "blindBox/boxDetailPage", params),
    status: params => axios.post(URL + "blindBox/updateBlindBoxStatus", params),
    boxList: params => axios.get(URL + "blindBox/blindBoxPrizeList", params),
    addBoxPrize: params => axios.post(URL + "blindBox/addBlindBoxPrize", params),
    editBoxPrize: params => axios.post(URL + "blindBox/editBlindBoxPrize", params),
    delBoxPrize: params => axios.post(URL + "blindBox/delBlindBoxPrize", params),
    copyBox: params => axios.post(URL + "blindBox/copyBox", params),
    blindManyPrizeList: params => axios.get(URL + "blindBox/blindManyPrizeList", params),
    addBlindManyPrize: params => axios.post(URL + "blindBox/addBlindManyPrize", params),
    editBlindManyPrize: params => axios.post(URL + "blindBox/editBlindManyPrize", params),
    delBlindManyPrize: params => axios.post(URL + "blindBox/delBlindManyPrize", params),
  },
  // pk盲盒列表
  pkBox: {
    index: params => axios.get(URL + "pk/index", params),
    add: params => axios.post(URL + "pk/addPkBox", params),
    edit: params => axios.post(URL + "pk/editPkBox", params),
    status: params => axios.post(URL + "pk/updatePkBoxStatus", params),
    pkBoxPrizeList: params => axios.get(URL + "pk/pkBoxPrizeList", params),
    addPkBoxPrize: params => axios.post(URL + "pk/addPkBoxPrize", params),
    editPkBoxPrize: params => axios.post(URL + "pk/editPkBoxPrize", params),
    delPkBoxPrize: params => axios.post(URL + "pk/delPkBoxPrize", params),
  },
  // 许愿池盲盒列表
  wishBox: {
    index: params => axios.get(URL + "wishBox/index", params),
    add: params => axios.post(URL + "wishBox/addWishBox", params),
    edit: params => axios.post(URL + "wishBox/editWishBox", params),
    detail: params => axios.get(URL + "wishBox/boxDetailPage", params),
    wishBoxList: params => axios.get(URL + "wishBox/wishBoxPrizeList", params),
    status: params => axios.post(URL + "wishBox/updateWishBoxStatus", params),
    addWishBox: params => axios.post(URL + "wishBox/addWishBoxPrize", params),
    editWishBox: params => axios.post(URL + "wishBox/editWishBoxPrize", params),
    delWishBox: params => axios.post(URL + "wishBox/delWishBoxPrize", params),
  },

  // 擂台盲盒列表
  challengeBox: {
    index: params => axios.get(URL + "challengeBox/index", params),
    add: params => axios.post(URL + "challengeBox/addChallengeBox", params),
    edit: params => axios.post(URL + "challengeBox/editChallengeBox", params),
    status: params => axios.post(URL + "challengeBox/updateChallengeBoxStatus", params),
    boxList: params => axios.get(URL + "challengeBox/challengeBoxPrizeList", params),
    addBoxPrize: params => axios.post(URL + "challengeBox/addChallengeBoxPrize", params),
    editBoxPrize: params => axios.post(URL + "challengeBox/editChallengeBoxPrize", params),
    delBoxPrize: params => axios.post(URL + "challengeBox/delChallengeBoxPrize", params),
    renewBox: params => axios.post(URL + "challengeBox/renewBox", params),
  },
  // 福利屋
  wealRooms: {
    index: params => axios.get(URL + "wealRooms/index", params),
    add: params => axios.post(URL + "wealRooms/addWealRooms", params),
    edit: params => axios.post(URL + "wealRooms/editWealRooms", params),
    del: params => axios.post(URL + "wealRooms/delWealRooms", params),
    boxList: params => axios.get(URL + "wealRooms/wealRoomPrizeList", params),
    addBoxPrize: params => axios.post(URL + "wealRooms/addWealRoomsPrize", params),
    editBoxPrize: params => axios.post(URL + "wealRooms/editWealRoomsPrize", params),
    delBoxPrize: params => axios.post(URL + "wealRooms/delWealRoomsPrize", params),
    userAttendList: params => axios.get(URL + "wealRooms/userAttendList", params),
    adminUserAttend: params => axios.post(URL + "wealRooms/adminUserAttend", params),
    userAttend: params => axios.post(URL + "wealRooms/userAttend", params),
  },
  // 幸运屋
  luckys: {
    index: params => axios.get(URL + "luckDraws/index", params),
    add: params => axios.post(URL + "luckDraws/addLuckDraws", params),
    edit: params => axios.post(URL + "luckDraws/editLuckDraws", params),
    del: params => axios.post(URL + "luckDraws/delLuckDraws", params),
    boxList: params => axios.get(URL + "luckDraws/getLuckDrawPrizeList", params),
    addBoxPrize: params => axios.post(URL + "luckDraws/addLuckDrawPrize", params),
    editBoxPrize: params => axios.post(URL + "luckDraws/editLuckDrawPrize", params),
    delBoxPrize: params => axios.post(URL + "luckDraws/delLuckDrawPrize", params),
    codeList: params => axios.get(URL + "luckDraws/getLuckDrawCodes", params),
    status: params => axios.post(URL + "luckDraws/updateLuckDrawStatus", params),
    luckDrawsHitPrizeDetail: params => axios.get(URL + "luckDraws/luckDrawsHitPrizeDetail", params),
    sysPrize: params => axios.post(URL + "luckDraws/sysPrize", params),
    getPrizeList: params => axios.post(URL + "luckDraws/getPrizeList", params),
    
  },
  //充值福利屋列表
  rechargeWealRoom: {
    index: params => axios.get(URL + "rechargeWealRoom/index", params),
    add: params => axios.post(URL + "rechargeWealRoom/addRechargeWealRoom", params),
    edit: params => axios.post(URL + "rechargeWealRoom/editRechargeWealRoom", params),
    del: params => axios.post(URL + "rechargeWealRoom/delRechargeWealRoom", params),
    status: params => axios.post(URL + "rechargeWealRoom/updateRechargeWealRoomStatus", params),
    boxList: params => axios.get(URL + "rechargeWealRoom/getRechargeWealRoomPrizeList", params),
    addBoxPrize: params => axios.post(URL + "rechargeWealRoom/addRechargeWealRoomPrize", params),
    editBoxPrize: params => axios.post(URL + "rechargeWealRoom/editRechargeWealRoomPrize", params),
    delBoxPrize: params => axios.post(URL + "rechargeWealRoom/delRechargeWealRoomPrize", params),
    codeList: params => axios.get(URL + "rechargeWealRoom/getRechargeWealRoomCodes", params),
    luckDrawsHitPrizeDetail: params => axios.get(URL + "rechargeWealRoom/rechargeWealRoomHitPrizeDetail", params),
    sysPrize: params => axios.post(URL + "rechargeWealRoom/sysPrize", params),
    getPrizeList: params => axios.post(URL + "rechargeWealRoom/getPrizeList", params),
  },
  // 闯关
  fightBox: {
    index: params => axios.get(URL + "fightBox/index", params),
    add: params => axios.post(URL + "fightBox/addFightBox", params),
    edit: params => axios.post(URL + "fightBox/editFightBox", params),
    status: params => axios.post(URL + "fightBox/updateFightBoxStatus", params),
    getFightBoxNumList: params => axios.get(URL + "fightBox/getFightBoxNumList", params),
    addFightBoxNum: params => axios.post(URL + "fightBox/addFightBoxNum", params),
    editFightBoxNum: params => axios.post(URL + "fightBox/editFightBoxNum", params),
    delFightBoxNum: params => axios.post(URL + "fightBox/delFightBoxNum", params),
    fightBoxPrizeList: params => axios.get(URL + "fightBox/fightBoxPrizeList", params),
    addFightBoxPrize: params => axios.post(URL + "fightBox/addFightBoxPrize", params),
    editFightBoxPrize: params => axios.post(URL + "fightBox/editFightBoxPrize", params),
    delFightBoxPrize: params => axios.post(URL + "fightBox/delFightBoxPrize", params),
  },
  // 任务
  task: {
    index: params => axios.get(URL + "task/taskList", params),
    runTaskList: params => axios.get(URL + "task/runTaskList", params),
    status: params => axios.post(URL + "task/updateRunTaskStatus", params),
  },
  // 爬塔
  climbTower: {
    index: params => axios.get(URL + "climbTower/index", params),
    add: params => axios.post(URL + "climbTower/addClimbTower", params),
    edit: params => axios.post(URL + "climbTower/editClimbTower", params),
    status: params => axios.post(URL + "climbTower/updateClimbTowerStatus", params),
    getClimbTowerNumList: params => axios.get(URL + "climbTower/getClimbTowerNumList", params),
    addClimbTowerNum: params => axios.post(URL + "climbTower/addClimbTowerNum", params),
    editClimbTowerNum: params => axios.post(URL + "climbTower/editClimbTowerNum", params),
    delClimbTowerNum: params => axios.post(URL + "climbTower/delClimbTowerNum", params),
    climbTowerPrizeList: params => axios.get(URL + "climbTower/climbTowerPrizeList", params),
    addClimbTowerPrizet: params => axios.post(URL + "climbTower/addClimbTowerPrize", params),
    editClimbTowerPrize: params => axios.post(URL + "climbTower/editClimbTowerPrize", params),
    delClimbTowerPrize: params => axios.post(URL + "climbTower/delClimbTowerPrize", params),
  },
  // 优惠券
  coupon: {
    index: params => axios.get(URL + "coupon/index", params),
    add: params => axios.post(URL + "coupon/addCoupon", params),
    edit: params => axios.post(URL + "coupon/editCoupon", params),
    del: params => axios.post(URL + "coupon/delCoupon", params),
    status: params => axios.post(URL + "coupon/updateCouponStatus", params),
  },
  //用户
  users: {
    getUserLevelList: params => axios.get(URL + "users/getUserLevelList", params),//用户等级列表
    index: params => axios.get(URL + "users/index", params),//用户列表
    userRecharge: params => axios.post(URL + "users/userRecharge", params),//用户充值
    userDeduct: params => axios.post(URL + "users/userDeduct", params),//用户扣除
    updateUserInfo: params => axios.post(URL + "users/updateUserInfo", params),//更新用户信息
    userCouponList: params => axios.get(URL + "users/userCouponList", params),//用户优惠券列表
    userCharge: params => axios.get(URL + "users/userChargeList", params),//用户充值列表
    userPrizeLogs: params => axios.get(URL + "users/userPrizeLogs", params),//用户赏袋日志
    userPrizeList: params => axios.get(URL + "users/userPrizeList", params),//用户赏袋
    userPrizeDetail: params => axios.get(URL + "users/userPrizeDetail", params),//用户赏袋详情
    usersGiveOrder: params => axios.get(URL + "users/giveOrder", params),//用户赠送列表
    usersGiveOrderDetail: params => axios.post(URL + "users/giveOrderDetail", params),//用户赠送详情
    usersAuditGiveOrder: params => axios.post(URL + "users/auditGiveOrder", params),//用户赠送审核
    energyLog: params => axios.get(URL + "log/energyLog", params),//用户能量记录
    fusionLog: params => axios.get(URL + "log/fusionLog", params),//用户融合记录
    customCommission: params => axios.get(URL + "users/customCommission", params),//用户定制返佣列表
    customCommissionDetail: params => axios.get(URL + "users/customCommissionDetail", params),//定制返佣详情
    getUserFirstSuperHuman: params => axios.get(URL + "users/getUserFirstSuperHuman", params),//获取首个超神
    getUserPrizeData: params => axios.get(URL + "users/getUserPrizeData", params),//获取用户赏袋数据
  },
  //日志
  logs: {
    balanceLog: params => axios.get(URL + "log/balanceLog", params),//用户余额记录
    pointLog: params => axios.get(URL + "log/pointLog", params),//用户钻石记录
    adminRechargeLog: params => axios.get(URL + "log/adminRechargeLog", params),//后台充值记录
    userLevelLog: params => axios.get(URL + "log/userLevelLog", params),//用户等级变更记录
    userApiRequestLog: params => axios.get(URL + "log/userApiRequestLog", params),//用户api请求日志
    userSignLog: params => axios.get(URL + "log/userSignLog", params),//用户签到日志
    blindPointLog: params => axios.get(URL + "log/blindPointLog", params),//无限币记录
    challengePointLog: params => axios.get(URL + "log/challengePointLog", params),//擂台币记录
    fightPointLog: params => axios.get(URL + "log/fightPointLog", params),//闯关币记录
    pkPointLog: params => axios.get(URL + "log/pkPointLog", params),//PK币记录
  },
  //区间配置
  blindPrizeSet: {
    index: params => axios.get(URL + "blindPrizeSet/index", params),
    add: params => axios.post(URL + "blindPrizeSet/addSet", params),
    del: params => axios.post(URL + "blindPrizeSet/delSet", params),
    edit: params => axios.post(URL + "blindPrizeSet/editSet", params),
  },
  //系统配置
  sysConfig: {
    index: params => axios.get(URL + "sysConfig/index", params),
    add: params => axios.post(URL + "sysConfig/sysAdd", params),
    del: params => axios.post(URL + "sysConfig/sysDel", params),
    edit: params => axios.post(URL + "sysConfig/sysEdit", params),
  },
  //融合
  fusionPrize: {
    index: params => axios.get(URL + "fusionPrize/index", params),
    add: params => axios.post(URL + "fusionPrize/addFusionPrize", params),
    del: params => axios.post(URL + "fusionPrize/delFusionPrize", params),
    edit: params => axios.post(URL + "fusionPrize/editFusionPrize", params),
    status: params => axios.post(URL + "fusionPrize/updateStatus", params),
  },
  //商城
  shopGoods: {
    index: params => axios.get(URL + "shopGoods/index", params),
    add: params => axios.post(URL + "shopGoods/addShopGoods", params),
    edit: params => axios.post(URL + "shopGoods/editShopGoods", params),
    status: params => axios.post(URL + "shopGoods/updateShopGoodsStatus", params),
  },
  //流水赠送配置
  givePoint: {
    index: params => axios.get(URL + "givePoint/index", params),
    add: params => axios.post(URL + "givePoint/addGivePoint", params),
    edit: params => axios.post(URL + "givePoint/editGivePoint", params),
    del: params => axios.post(URL + "givePoint/delGivePoint", params),
  },
  //签到配置
  signPanel: {
    index: params => axios.get(URL + "signPanel/index", params),
    add: params => axios.post(URL + "signPanel/addSignPanel", params),
    edit: params => axios.post(URL + "signPanel/editSignPanel", params),
    del: params => axios.post(URL + "signPanel/delSignPanel", params),
  },
  //内容分类列表
  contentcateList: {
    index: params => axios.get(URL + "content/cateList", params),
    add: params => axios.post(URL + "content/addContentCate", params),
    edit: params => axios.post(URL + "content/editContentCate", params),
    del: params => axios.post(URL + "content/delContentCate", params),
  },
  //内容列表
  contentList: {
    index: params => axios.get(URL + "content/contentList", params),
    add: params => axios.post(URL + "content/addContent", params),
    edit: params => axios.post(URL + "content/editContent", params),
    del: params => axios.post(URL + "content/delContent", params),
  },
  //轮播列表
  banners: {
    index: params => axios.get(URL + "banners/index", params),
    add: params => axios.post(URL + "banners/addBanner", params),
    edit: params => axios.post(URL + "banners/editBanner", params),
    del: params => axios.post(URL + "banners/delBanner", params),
    status: params => axios.post(URL + "banners/updateBannerStatus", params),
  },
  //亏损列表
  loss: {
    index: params => axios.get(URL + "loss/index", params),//亏损列表
    detail: params => axios.get(URL + "loss/lossDetail", params),//获取用户亏损详情
    dayLoss: params => axios.get(URL + "loss/lossDaysDetail", params),//获取每一天的亏损
    flowRank: params => axios.get(URL + "common/flowRank", params),//排行榜
    userChallengeNum: params => axios.get(URL + "common/userChallengeNum", params),//上车次数排名
    userLossByType: params => axios.get(URL + "common/userLossByType", params),//按类型查询用户亏损
    pkRoomRecord: params => axios.get(URL + "pkBox/pkRoomRecord", params),//pk房间记录
    boxOrdersIndex: params => axios.get(URL + "boxOrders/index", params),//业务订单数据
    boxOrdersBoxOrderDetail: params => axios.get(URL + "boxOrders/boxOrderDetail", params),//业务订单数据详情
    getPlatformStatistical: params => axios.get(URL + "common/getPlatformStatistical", params),//平台统计数据
    getUserStatistical: params => axios.get(URL + "common/getUserStatistical", params),//用户统计数据
  },
  //配送地址列表
  areas: {
    index: params => axios.get(URL + "areas/index", params),//区域列表
    freightList: params => axios.get(URL + "areas/freightList", params),//运费列表
    add: params => axios.post(URL + "areas/freightAdd", params),
    edit: params => axios.post(URL + "areas/freightEdit", params),
    del: params => axios.post(URL + "areas/freightDel", params),
  },
  //B列表
  bl: {
    index: params => axios.get(URL + "bl/index", params),
    add: params => axios.post(URL + "bl/addUser", params),
    del: params => axios.post(URL + "bl/delUser", params),
  },
  //w列表
  wl: {
    index: params => axios.get(URL + "wl/index", params),
    add: params => axios.post(URL + "wl/addUser", params),
    del: params => axios.post(URL + "wl/delUser", params),
  },
  //主题活动
  theme: {
    index: params => axios.get(URL + "theme/index", params),
    add: params => axios.post(URL + "theme/addTheme", params),
    edit: params => axios.post(URL + "theme/editTheme", params),
    status: params => axios.post(URL + "theme/updateThemeStatus", params),
    themeGoodsList: params => axios.get(URL + "theme/themeGoodsList", params),
    addThemeGoods: params => axios.post(URL + "theme/addThemeGoods", params),
    delThemeGoods: params => axios.post(URL + "theme/delThemeGoods", params),
  },
  
};
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js